import { Link, useLocation } from 'react-router-dom';
import { forumCategories } from '@/mocks/forumData';

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  if (pathSegments.length === 0) return null;

  const breadcrumbs: { label: string; path: string }[] = [
    { label: '首页', path: '/' },
  ];

  if (pathSegments[0] === 'category') {
    breadcrumbs.push({ label: '版块浏览', path: '/category/zonghe-jiaoliu' });
    if (pathSegments[1]) {
      const cat = forumCategories.find((c) => c.slug === pathSegments[1]);
      breadcrumbs.push({
        label: cat ? cat.name : pathSegments[1],
        path: `/category/${pathSegments[1]}`,
      });
    }
  } else if (pathSegments[0] === 'article') {
    breadcrumbs.push({ label: '文章阅读', path: '#' });
  } else if (pathSegments[0] === 'about') {
    breadcrumbs.push({ label: '关于我们', path: '/about' });
  }

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {breadcrumbs.map((crumb, index) => (
          <li key={crumb.path} className="flex items-center gap-1">
            {index > 0 && (
              <span className="text-foreground-400 mx-1">
                <i className="ri-arrow-right-s-line text-xs"></i>
              </span>
            )}
            {index < breadcrumbs.length - 1 ? (
              <Link
                to={crumb.path}
                className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
              >
                {crumb.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium whitespace-nowrap">{crumb.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}